export default __webpack_public_path__ + "static/media/mc_2.dcd55114.png";